import { render } from "./LocationExport.vue?vue&type=template&id=7d27bfec"
import script from "./LocationExport.vue?vue&type=script&lang=ts"
export * from "./LocationExport.vue?vue&type=script&lang=ts"
script.render = render

export default script